<template>
  <router-view/>
</template>
<script setup >
import {useCounterStore} from '@/store'
import {post} from "@/http/axios";
import baseApi from "@/http/api/user";
import {onMounted} from "vue";

const commonStore = useCounterStore()
onMounted(()=>{
  getParkInfo()
})
const getParkInfo = async () => {
  const {data: parkList}= await post(baseApi.parkInfo, null)
  // commonStore.parkList = parkList.rows
  parkList.rows.unshift({parkId:'',parkName:'全部'})
  commonStore.parkList = parkList.rows
  // const list = []
  // parkList.rows.forEach(item => {
  //   list.push({parkId: item.parkId, parkName: item.parkName})
  // })
  // parkListInfo.value = list
  // console.log('21332',commonStore.userInfo)
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,body{
  height: 100%;
}
nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

</style>
